import { apiEndpoints } from '@/apiEndpoints';
import axios from 'axios';

type ExchangeRateResponse = {
  rates: Record<string, number>;
};

export type AgencyExchangeRateRow = {
  quoteCurrency: string;
  baseCurrency: string;
  rate: number | null;
  marketRate: number;
  usesMarketRate: boolean;
};

export type AgencyExchangeRatesResponse = {
  baseCurrency: string;
  rates: AgencyExchangeRateRow[];
};

export type EffectiveRatesResponse = {
  baseCurrency: string;
  rates: Record<string, number>;
  overrides: { quoteCurrency: string; rate: number | null }[];
};

export const getExchangeRate = async () => {
  const response = await axios.get<ExchangeRateResponse>(
    apiEndpoints.currencyExchange.latest,
  );
  return response.data;
};

export const getClosestCurrencyExchangeRatesToDate = async (date: Date) => {
  const response = await axios.get<ExchangeRateResponse>(
    apiEndpoints.currencyExchange.closestToDate,
    {
      params: {
        date: date.toISOString(),
      },
    },
  );
  return response.data;
};

export const getAgencyExchangeRates = async () => {
  const response = await axios.get<AgencyExchangeRatesResponse>(
    apiEndpoints.currencyExchange.agencyRates,
  );
  return response.data;
};

export const getEffectiveExchangeRates = async (date?: Date) => {
  const response = await axios.get<EffectiveRatesResponse>(
    apiEndpoints.currencyExchange.effectiveRates,
    {
      params: date ? { date: date.toISOString() } : undefined,
    },
  );
  return response.data;
};

export const upsertAgencyExchangeRate = async (payload: {
  quoteCurrency: string;
  rate: number;
}) => {
  const response = await axios.post<AgencyExchangeRatesResponse>(
    apiEndpoints.currencyExchange.agencyRates,
    payload,
  );
  return response.data;
};

export const useMarketExchangeRate = async (quoteCurrency: string) => {
  const response = await axios.post<AgencyExchangeRatesResponse>(
    apiEndpoints.currencyExchange.useMarketRate,
    { quoteCurrency },
  );
  return response.data;
};
